export default __webpack_public_path__ + "assets/ico_checked-7fff9a8d.svg";